import { FlatIconButton, IPagination } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface Props {
	pagination: Omit<IPagination, "size">;
	onChange: (pageNumber: number) => void;
}

const Wrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: right;
`;

const Page = styled.div`
	${({ theme }) => theme.pagination.page};
`;

export const SimplePagination: FC<Props> = ({ pagination: { page, last, total, from, to }, onChange }) => {
	const { t } = useTranslation();

	return (
		<Wrapper>
			<Page>
				{from}-{to} {t("of")} {total}
			</Page>
			<FlatIconButton
				title={t("Previous page")}
				disabled={page === 1}
				onClick={() => onChange(page - 1)}
				icon="caret_left"
			/>
			<FlatIconButton title={t("Next page")} disabled={page === last} onClick={() => onChange(page + 1)} icon="caret" />
		</Wrapper>
	);
};
